export const MYPAGE_DASHBOARD = 'dashboard';
export const MYPAGE_API_MANAGEMENT = 'api_management';
export const MYPAGE_MESSAGE = 'message';
